import { env } from "@/app/config/env";

/**
 * WHICH BUILD AM I LOOKING AT — answered on the screen, not in a settings page.
 *
 * Three identities that look identical is a long afternoon: a bug reproduced against the
 * wrong database, a "fixed" thing that was never deployed. This renders on every build
 * except production, so if you can see it, you are not on the live one.
 */
export function DevBar() {
  if (!env.showsDevBar) return null;

  return (
    // No `pt-safe`: the root layout owns the inset, in every environment.
    <div className="bg-muted text-muted-foreground">
      <p className="text-legal px-3 py-1 text-center tabular-nums">
        {env.appEnv.toUpperCase()} · v{env.version} · {new URL(env.apiUrl).host}
      </p>
    </div>
  );
}
